import type { Theme } from "./storage";

const SURFACE = { light: "#faf9f6", dark: "#141820" };

/** Applies a theme to <html> and the browser chrome (status bar, title bar). */
export function applyTheme(theme: Theme) {
  const root = document.documentElement;
  if (theme === "system") delete root.dataset.theme;
  else root.dataset.theme = theme;
  // Two theme-color metas carry media queries for the system theme; an explicit
  // choice gives both the same colour so whichever one matches shows it.
  for (const meta of document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')) {
    const own = meta.media.includes("dark") ? SURFACE.dark : SURFACE.light;
    meta.content = theme === "system" ? own : SURFACE[theme];
  }
}

/** Cross-fades the switch where supported; instant with reduced motion. */
export function switchTheme(theme: Theme) {
  const doc = document as Document & { startViewTransition?: (cb: () => void) => unknown };
  if (doc.startViewTransition && !matchMedia("(prefers-reduced-motion: reduce)").matches)
    doc.startViewTransition(() => applyTheme(theme));
  else applyTheme(theme);
}
